import { render, staticRenderFns } from "./financeiro-tabela-regras-agenda-garantia-minima.vue?vue&type=template&id=6b190868&scoped=true"
import script from "./financeiro-tabela-regras-agenda-garantia-minima.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-regras-agenda-garantia-minima.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-regras-agenda-garantia-minima.vue?vue&type=style&index=0&id=6b190868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b190868",
  null
  
)

export default component.exports